























import Vue from 'vue'
import Elements from '@/components/parsers/Elements.vue'
import { darkColors, lightColors } from '@/config/colors'

export default Vue.extend({
  name: 'Item',

  data: () => ({
    resetStylesForElements: [
      'telenorForYou',
      'profile',
      'biometricSwitch',
      'telenorForYouNoPic',
      'profileNoPic',
      'confirmationMessage',
      'infoMessage',
      'carousel',
      'headerCarousel',
      'headerCarousel2',
      'blockStatus'
    ]
  }),

  components: { Elements },

  props: {
    mainData: {
      required: true
    },
    isFirstItemAfterHeaderTheme: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    /*
    Sets page background based on certain rules:
    1) If an item has no 'style' property, uses default color
    2) if an item has 'style' property and is of theme 'defaultGrouped', background is always default
    3) If an item has 'style' property, is not 'defaultGrouped' and has background property, uses that color
    4) In all other cases, uses default background
     */
    pageBackground (): string {
      if (!Object.prototype.hasOwnProperty.call(this.$props.mainData, 'style')) {
        return 'itemBackground'
      }
      const style = this.$props.mainData.style
      const background = style.pageBackground || style.theme.pageBackground
      if (this.hasGroupTheme) {
        return 'itemBackground'
      } else {
        return background || 'appDefault'
      }
    },
    isThemeGrouped (): boolean {
      if (!Object.prototype.hasOwnProperty.call(this.$props.mainData, 'style')) {
        return false
      }
      const style = this.$props.mainData.style
      // Reset styles for certain elements (remove background and paddings/margins)
      if (this.shouldResetElement()) {
        return false
      }
      return style.theme === 'defaultGrouped'
    },
    isThemeGroupedTop (): boolean {
      return this.checkIsTheme('groupedTop')
    },
    isThemeGroupedBottom (): boolean {
      return this.checkIsTheme('groupedBottom')
    },
    isThemeHeaderGreen (): boolean {
      return this.checkIsTheme('headerGreen')
    },
    resolveClasses (): string {
      if (this.isThemeGrouped || this.isThemeGroupedTop) {
        return 'mt-3 mx-2 py-2'
      }
      if (this.isThemeHeaderGreen) {
        return ''
      }
      if (this.isThemeGroupedBottom) {
        return 'mx-2 pb-2'
      }
      return 'mt-3 mx-2'
    },
    resolveStyles (): string {
      if (this.isFirstItemAfterHeaderTheme && !this.isDesktop) {
        return 'margin-top: -2.5rem !important;'
      }
      if (this.isThemeGroupedTop) {
        return 'border-radius: var(--default-border-radius) var(--default-border-radius) 0 0;' +
          'box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.12) !important;'
      }
      if (this.isThemeGroupedBottom) {
        return 'border-radius: 0 0 var(--default-border-radius) var(--default-border-radius);' +
          'box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;' +
          'margin-top: 2px;'
      }
      return ''
    },
    elementsBackground (): string {
      if (!Object.prototype.hasOwnProperty.call(this.$props.mainData, 'style')) {
        return 'transparent'
      }
      const groupThemeColors = this.$vuetify.theme.dark ? darkColors.itemBackground : lightColors.itemBackground
      const colors = this.$vuetify.theme.dark ? darkColors.textBackground : (this.$props.mainData.style.pageBackground || 'transparent')
      return this.hasGroupTheme ? groupThemeColors : colors
    },
    hasGroupTheme (): boolean {
      return this.isThemeGrouped || this.isThemeGroupedTop || this.isThemeGroupedBottom
    }
  },

  methods: {
    /*
    Certain elements should not have the default box that the theme 'defaultGrouped' provides
    For these elements, we 'reset' their theme so that we can customize them more
    */
    shouldResetElement (): boolean {
      if (!Object.prototype.hasOwnProperty.call(this.$props.mainData, 'elements')) {
        return false
      }
      const elements = this.$props.mainData.elements as Array<Record<string, string>>
      for (let i = 0; i < elements.length; i++) {
        if (this.resetStylesForElements.indexOf(elements[i].type) !== -1) {
          return true
        }
      }
      return false
    },
    checkIsTheme (theme: string): boolean {
      if (!Object.prototype.hasOwnProperty.call(this.$props.mainData, 'style')) {
        return false
      }
      const style = this.$props.mainData.style
      return style.theme === theme
    }
  }
})
